import { useLocation, Navigate, Outlet } from "react-router-dom"
import { useSelector } from "react-redux"
import { getUser } from "./authSlice"

const RequireAdmin = () => {
    const user = useSelector(getUser)
    const location = useLocation()
    return (
        user.permissions.includes("admin")
            ? <Outlet />
            : <Navigate to={`${process.env.REACT_APP_PREFIX}/login`} state={{ from: location }} replace />
    )
}
export default RequireAdmin